import { Outlet, createFileRoute } from '@tanstack/react-router';

import { AdminShell } from '@/features/organization-admin';
import { FeatureErrorBoundary } from '@/shared/components/FeatureErrorBoundary';

export const Route = createFileRoute('/admin')({
  component: AdminLayoutRoute,
});

/**
 * The console's own tree, above the workspace boundary (spec 073 FR-001).
 *
 * A sibling of `/workspaces`, not a child of one. Nothing here takes a `workspaceId`,
 * and the shell it renders is the console's rather than the workspace one — which is
 * what keeps a console that must offer no route into a workspace's contents (FR-006)
 * from being wrapped in twelve of them.
 *
 * The role gate lives in `AdminShell` rather than in a `beforeLoad` here. A `beforeLoad`
 * would have to read identity before the router could render anything, turning a page
 * that explains a refusal into a blank screen while it waits — and the refusal is the
 * thing FR-004 asks for.
 */
export function AdminLayoutRoute() {
  return (
    <AdminShell>
      <FeatureErrorBoundary>
        <Outlet />
      </FeatureErrorBoundary>
    </AdminShell>
  );
}
